export default "__VITE_ASSET__dd61abb9__"